import {
  MARKET_LOADING,
  GET_MARKET,
  GET_MARKET_SUCCESS,
  GET_MARKET_FAIL,
  ADD_MARKET_SUCCESS,
  ADD_MARKET_FAIL,
  DELETE_MARKET_SUCCESS,
  DELETE_MARKET_FAIL,
  UPDATE_MARKET_SUCCESS,
  UPDATE_MARKET_FAIL,
  MARKET_RESET,
} from "./actionType";

const INIT_STATE = {
  markets: [],
  error: {},
};

const Market = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_MARKET_SUCCESS:
      switch (action.payload.actionType) {
        case GET_MARKET:
          return {
            ...state,
            markets: action.payload.data,
            isMarketCreated: false,
            isMarketSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_MARKET_FAIL:
      switch (action.payload.actionType) {
        case GET_MARKET_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isMarketCreated: false,
            isMarketSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_MARKET: {
      return {
        ...state,
        isMarketCreated: false,
        loading: true,
      };
    }

    case MARKET_LOADING: {
      return {
        ...state,
        isMarketCreated: false,
        loading: true,
      };
    }

    case ADD_MARKET_SUCCESS:
      return {
        ...state,
        isMarketCreated: true,
        loading: false,
        markets: [action.payload.data, ...state.markets],
      };

    case ADD_MARKET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_MARKET_SUCCESS:
      return {
        ...state,
        loading: false,
        isMarketCreated: true,
        markets: state.markets.filter(
          (market) => market.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_MARKET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_MARKET_SUCCESS:
      return {
        ...state,
        loading: false,
        isMarketCreated: true,
        markets: state.markets.map((market) =>
          market.id.toString() === action.payload.data.id.toString()
            ? { ...market, ...action.payload.data }
            : market
        ),
      };

    case UPDATE_MARKET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case MARKET_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Market;
